import { httpRequest } from 'http'
import normalizeSlotInfo from 'state/schemas/slots'
import { sendErrorNotification } from 'helpers/web_to_client'

export const SLOT_INFO_REQUEST = 'slots/SLOT_INFO_REQUEST'
export const SLOT_INFO_SUCCESS = 'slots/SLOT_INFO_SUCCESS'
export const SLOT_INFO_ERROR = 'slots/SLOT_INFO_ERROR'

export function slotInfoRequestStart(slotId) {
    return {
        type: SLOT_INFO_REQUEST,
        payload: { slotId },
    }
}

export function slotInfoRequestSuccess(data) {
    const { building, slot } = normalizeSlotInfo(data)
    return {
        type: SLOT_INFO_SUCCESS,
        payload: { building, slot },
    }
}

export function slotInfoRequestError(errorData, slotId) {
    sendErrorNotification(errorData)
    return {
        type: SLOT_INFO_ERROR,
        payload: {
            ...errorData,
            slotId,
        },
    }
}

export default function requestSlotInfo(slotId) {
    return async (dispatch, getState) => {
        const slot = getState().slots[slotId]
        if (slot.loading) {
            return
        }

        dispatch(slotInfoRequestStart(slotId))
        httpRequest(`/game_api/slot_building/${slotId}`)
            .then(
                data => dispatch(slotInfoRequestSuccess(data)),
                errorData => dispatch(slotInfoRequestError(errorData, slotId))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/slots.js